<template>
  <div>
    <b-modal
      title="身故名單"
      size="lg"
      centered
      hide-footer
      header-class="head-modal"
      v-model="modalShow"
    >
      <b-form-group label-cols="auto" label-cols-lg="auto" label="期別(民國年月份)">
        <!-- <b-form-input
          class="mb-2"
          placeholder="期別"
          v-model="search.period"
          @keyup.enter="getDeadList(1)" /> -->
        <roc-date-picker-year-month
          v-model="search.period"
          @dateChange="getDeadList(1)" />
      </b-form-group>

      <tables-page
        :tableData="table_data"
        :tableFields="table_fields"
      >
        <template #cell(dead_at)="row">
          {{ convertRocDate(row.item.dead_at) }}
        </template>

        <template #cell(member_ID_number)="row">
          {{ isMaskData ? maskData(row.item.member_ID_number, 'ID') : row.item.member_ID_number }}
        </template>

        <template #cell(member_name)="row">
          {{ isMaskData ? maskData(row.item.member_name, 'name') : row.item.member_name }}
        </template>

        <template #cell(death_certificate)="row">
          <div class="link death-certificate" @click="openImgModal(row.item, false)">{{ row.item.claim_image }}</div>
        </template>
      </tables-page>

      <!-- 圖片 modal -->
      <img-modal
        :img="imgUrl"
        :isUpload="status.isUpload"
        v-model="status.imgModal"/>

      <b-overlay :show="status.isLoading" no-wrap></b-overlay>
    </b-modal>
  </div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import contractApi from "@/models/API/contractApi";
import RocDatePickerYearMonth from "@/components/common/RocDatePickerYearMonth";
import { convertRocDate, getRocYearAndMonthOfPeriod, maskData } from "@/models/HELPERS/common.js";
import ImgModal from "@/components/common/Modal/imgModal";

export default {
  name: 'DeadListModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    member_id: {
      type: Number,
      required: true
    },
    isMaskData: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: {
    TablesPage,
    ImgModal,
    RocDatePickerYearMonth
  },
  data () {
    return {
      search: {
        period: ''
      },
      status: {
        imgModal: false,
        isUpload: false,
        isLoading: false
      },
      table_fields: [
        {
          key: "no",
          label: "No",
        },
        {
          key: "plan",
          label: "組別",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_ID_number",
          label: "身分證",
        },
        {
          key: "member_name",
          label: "姓名",
        },
        {
          key: "dead_at",
          label: "身故日期",
        },
        {
          key: "period",
          label: "期別",
        },
        {
          key: "death_certificate",
          label: "身故證明檔"
        },
      ],
      table_data: [],
      temp_table_data: {},
      imgUrl:''
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) {
          this.search.period = getRocYearAndMonthOfPeriod();

          this.getDeadList();
        }
      },
      immediate: false
    }
  },
  mounted() {
    this.contractApi = new contractApi();
  },
  methods: {
    convertRocDate,
    maskData,
    // 查詢身故名單
    getDeadList() {
      this.status.isLoading = true;

      const params = {
        ...this.search,
        'member_id': this.member_id
      };

      this.contractApi.getDeadList((response) => {
        const res = response.data;

        this.table_data = res.data.map((item, index) => {
          return {
            ...item,
            no: index + 1
          }
        });

         this.status.isLoading = false;
      }, params, false)
    },
    // 開啟圖片 modal
    openImgModal(item = null, is_upload = true) {
      this.status.imgModal = true;
      this.status.isUpload = is_upload;

      this.temp_table_data = Object.assign({}, item);
      this.imgUrl = `${process.env.IMAGEPATH}/storage/files/${item.claim_image}`
    },
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/Modal/DeadListModal.vue